import { render, staticRenderFns } from "./StockValueDialogWidget.vue?vue&type=template&id=5cf9c1f4&"
import script from "./StockValueDialogWidget.vue?vue&type=script&lang=js&"
export * from "./StockValueDialogWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpinner,QInput,QSelect,QIcon,QPopupProxy,QDate,QBtn,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpinner,QInput,QSelect,QIcon,QPopupProxy,QDate,QBtn,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
